module.exports = __webpack_public_path__ + "img/logo-company.3785602d.png";